export { default } from "bullitttime-embercomponents/components/inline-edit";
